import createReactComponent from '../createReactComponent';
export default createReactComponent('gauge', 'IconGauge', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-1' }],
  ['path', { d: 'M13.41 10.59l2.59 -2.59', key: 'svg-2' }],
  ['path', { d: 'M7 12a5 5 0 0 1 5 -5', key: 'svg-3' }],
]);
